var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['HtButton',_vm.type],on:{"click":_vm.click}},[_vm._t("iconClass"),_vm._v(" "),_c('i',{class:['iconfont',_vm.iconClassName]}),_vm._v(" "),_c('span',{staticClass:"btn-txt"},[_vm._v(_vm._s(_vm.text))])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }